import { NodeModel } from "@minoru/react-dnd-treeview";
import { Box, Button, TextField } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { ErrorModal } from "../../../../../../../components/modals/error-modal";
import MesfModal from "../../../../../../../components/modals/modal.mesf";
import { ButtonWithLoading } from "../../../../../../../components/shared/buttons/button-with-loading";
import { TagFromTree } from "../../../models/TrendingModelsV2";
import { upsertTagFolder } from "../../../repository/TrendingRepositoryV2";

interface Props {
	open: boolean;
	handleClose: (shouldUpdate: boolean) => void;
	tagNodeSelectedInTree: NodeModel<TagFromTree> | null;
}
export const NewFolderModal = ({
	open,
	handleClose,
	tagNodeSelectedInTree,
}: Props) => {
	const [name, setName] = useState<string>();
	const [error, setError] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const updateTagFolder = useMutation({
		mutationFn: upsertTagFolder,
		onError: (error: Error) => {
			setError(error.message);
		},
	});

	const onSubmit = async (e: any) => {
		e.preventDefault();

		const parentId = Number(tagNodeSelectedInTree?.parent) || null;
		const parentTagId =
			tagNodeSelectedInTree?.data?.TagTypeCode === "F"
				? Number(tagNodeSelectedInTree.id)
				: parentId;

		setIsLoading(true);
		if (name) {
			await updateTagFolder.mutate({
				tagFolderId: null,
				parentTagFolderId: parentTagId,
				tagFolderName: name,
				isActive: true,
			});
		}

		handleClose(true);
		setName("");
		setIsLoading(false);
	};

	return (
		<>
			<MesfModal
				open={open}
				handleClose={() => handleClose(false)}
				maxWidth={"lg"}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				title="New folder"
			>
				<MesfModal.Content>
					<Box>
						<TextField
							style={{ minWidth: "600px" }}
							id="outlined-basic"
							label="Folder name"
							variant="outlined"
							value={name}
							onChange={(e) => setName(e.target.value)}
						/>
					</Box>
				</MesfModal.Content>
				<MesfModal.Actions>
					<div>
						<Button
							color="secondary"
							variant="outlined"
							onClick={() => handleClose(false)}
						>
							Cancel
						</Button>
					</div>
					<div>
						<ButtonWithLoading
							isLoading={isLoading}
							onClick={onSubmit}
							color="primary"
							variant="contained"
						>
							Save
						</ButtonWithLoading>
					</div>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
